import React from 'react';
import { SESSION_STORAGE_CURRENT_BOOKING } from '../../commons/constants';
import { getCookies, getSessionStorageItem } from '../../commons/utils';
import { LDUser } from '../../commons/ld-user';

const AviosContainer = ({ lang }) => {
  const bookingInfo = getSessionStorageItem(SESSION_STORAGE_CURRENT_BOOKING);
  const aviosTotal = (bookingInfo?.price?.total ?? 0) - (bookingInfo?.price?.gratuities ?? 0);
  const guests = JSON.stringify(
    bookingInfo?.guests?.map((guest) => ({
      firstName: guest.firstName,
      lastName: guest.lastName,
    })),
  );

  import('@rcg/avios-form-component');

  return (
    <avios-form-component
      data-testid="avios-form-component"
      price={aviosTotal}
      country={bookingInfo?.country?.code}
      currency={bookingInfo?.country?.currencies?.[0].symbol}
      language={lang}
      room-type={bookingInfo?.stateroom?.type.split('/')[0]}
      booking-id={bookingInfo?.id}
      ship-code={bookingInfo?.sailing?.itinerary?.ship?.code}
      sail-date={bookingInfo?.sailing?.sailDate}
      guests={guests}
      rwd-id={LDUser()}
      consumer-id={getCookies('consumerID') || ''}
      mcm-id={getCookies('MCMID') || ''}
      show-message-when-not-eligible="false"
    />
  );
};

export default AviosContainer;
